<template>
  <v-dialog v-model="store.imageDialog" width="500">
    <v-card :loading="store.imageUploadLoading">
      <v-card-title class="text-subtitle-2 grey">
        <v-chip class="me-2" label>#{{ store.imageUploadId }}</v-chip>
        Numaralı kayıt için görsel yükleme
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-file-input
          v-model="store.imageFile"
          filled
          prepend-icon
          :prepend-inner-icon="icons.mdiPaperclip"
          placeholder="Görsel seçimi yapınız"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text>Vazgeç</v-btn>
        <v-btn @click="store.imageSaveFn" depressed color="secondary">
          Yükle
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
// Pinia
import { useCashReportStore } from "./store";

// Icons
import { mdiPaperclip, mdiUpload } from "@mdi/js";

export default {
  setup() {
    const store = useCashReportStore();

    return {
      store,

      // icons
      icons: {
        mdiPaperclip,
        mdiUpload,
      },
    };
  },
};
</script>
